import React from 'react';

const PrivacyPopup = () => {
  return null; // Remove cookie component
};

export default PrivacyPopup;